export enum EventType {
    Virtual = 0,
    InPerson = 1,
    ZoomMeeting = 2,
    GenericActivity = 3,
    Questionnaire = 4,
    VideoActivity = 5,
}
